import { decodeToken as decodeSharedToken } from "@bezoned/shared/auth/token-utils.js";

const MILLISECONDS_PER_SECOND = 1000;
const MINUTES_PER_HOUR = 60;
const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = MINUTES_PER_HOUR * SECONDS_PER_MINUTE;

export function decodeToken(token: string) {
  return decodeSharedToken(token);
}

export function getTokenExpiryTime(token: string | null | undefined) {
  if (!token) {
    return null;
  }

  const payload = decodeSharedToken(token);
  return payload.exp ? payload.exp * MILLISECONDS_PER_SECOND : null;
}

export function getTokenIssuedAtTime(token: string | null | undefined) {
  if (!token) {
    return null;
  }

  const payload = decodeSharedToken(token);
  return payload.iat ? payload.iat * MILLISECONDS_PER_SECOND : null;
}

export function shouldRefreshToken(
  token: string | null | undefined,
  earlyRefreshFactor = 0.75
) {
  if (!token) {
    return true;
  }

  const expiryTime = getTokenExpiryTime(token);
  if (!expiryTime) {
    return true;
  }

  const now = Date.now();
  const timeToExpiry = expiryTime - now;
  const tokenTotalLifetime =
    expiryTime -
    (getTokenIssuedAtTime(token) ||
      now - SECONDS_PER_HOUR * MILLISECONDS_PER_SECOND);

  return timeToExpiry < tokenTotalLifetime * (1 - earlyRefreshFactor);
}
